var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-breadcrumb-cartao',{attrs:{"titulo":"Prestadores","breadcrumb":_vm.bread,"iconeSvg":_vm.PrestadoresSvg}},[_c('TabelaPrestadores',{attrs:{"habilitar-filtro-intercambio":_vm.habilitarFiltroIntercambio}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }